var components = {
  uLazyLoad: function () {
    return import(
      /* webpackChunkName: "node-modules/uview-ui/components/u-lazy-load/u-lazy-load" */ "uview-ui/components/u-lazy-load/u-lazy-load.vue"
    )
  },
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }